import { useTranslation } from '~src/i18n/use-translation';
import { fromAPIAmount } from '~src/utils/amount';

interface Props {
  value: number | undefined;
  currency: string | undefined;
}

export function Currency(props: Props) {
  const { value, currency } = props;
  const { i18n } = useTranslation();

  if (!value || !currency) {
    return false;
  }

  return new Intl.NumberFormat(i18n.resolvedLanguage, { style: 'currency', currency }).format(
    // This number cast might look a little uneccesary, but it's due to a runtime type issue where we
    // change the type of uint64 to a number, but in reality (runtime) it's actually a string.
    fromAPIAmount({ value: Number(value), currency })!
  );
}
